import { BuildAxiosRequestHeaders, AxiosRequest } from "../Utils/Request/Axios";

let baseUrl = "https://connecthealth.azure-api.net/cher/api";
export default async function sendQuestionnaireData(
    formikValues,
    questionnaireUUID,
    UUID,
    answersUuid,
    questionnaireDetails,
    setRetryingSubmission
) {
    //parse and then stringify so that a copy is created instead of a reference
    let encodedJsonData = await encodeAnswers(JSON.parse(JSON.stringify(formikValues)));

    //match values with questionnaire data
    let detailedJson = await generateDetailedJson(
        questionnaireDetails,
        encodedJsonData,
        UUID,
        questionnaireUUID,
        answersUuid
    );

    //format jsonData to match format:
    let formattedJson = JSON.stringify({
        requestJson: {
            results: [detailedJson],
        },
    });

    if (questionnaireUUID == "testingElements") {
        console.log(formattedJson);
        return;
    }

    let options = BuildAxiosRequestHeaders(questionnaireUUID, "ReturnCHQuestionnaireV2");
    let result = "";

    for (let i = 0; i < 3; i++) {
        try {
            result = await AxiosRequest(baseUrl, formattedJson, options);
        } catch (e) {
            return 399; //no response
        }

        if (result.data.StatusCode == 200) {
            break;
        } else {
            setRetryingSubmission(true);
        }
    }

    setRetryingSubmission(false);

    return { StatusCode: result.data.StatusCode, statusMessage: result.data.statusMessage };
}

async function encodeAnswers(jsonData) {
    for (var question in jsonData) {
        let answer = jsonData[question];
        if (typeof answer == "object") {
            answer = JSON.stringify(answer);
        }
        answer = await encode(answer.toString());

        jsonData[question] = answer;
    }

    return jsonData;
}

async function encode(text) {
    text.replace(/\\n/g, "\\n").replace(/\\'/g, "\\'").replace(/\\"/g, '\\"');
    text = await encodeURI(text);

    return text;
}

async function generateDetailedJson(questionnaireDetails, encodedJsonData, UUID, questionnaireUUID, answersUuid) {
    //make copy of questionnaire json
    questionnaireDetails = JSON.parse(JSON.stringify(questionnaireDetails[0][0]));
    questionnaireDetails["UUID"] = UUID;
    questionnaireDetails["questionnaireUUID"] = questionnaireUUID;
    questionnaireDetails["a"] = answersUuid;

    await questionnaireDetails["questions"].forEach(async (element) => {
        //set the value from formik to the value of the question
        if (encodedJsonData[element["name"]] != null) {
            let value = encodedJsonData[element["name"]].split(await encode("[$£.;.£$]"));

            element["rawValue"] = value.length > 1 ? value[1] : value[0];
            element["textValue"] = value[0];
        }

        [
            "initialDisclaimer",
            "finalDisclaimer",
            "answerType",
            "name",
            "page",
            "sliderRange",
            "options",
            "choices",
            "followUpOption",
            "customChoiceOption",
            "increment",
            "marks",
            "textFieldTitle",
            "checkBoxesTitle",
            "questions",
            "subQuestions",
            "followUpOptions",
            "optionsArray",
            "checkBoxes",
            "value",
            "selectColours",
            "support",
            "changePositionText",
            "labels",
            "questionCText",
            "listHeaderId",
            "requiredQuestions",
            "readOnly",
        ].forEach((key) => {
            delete element[key];
        });
    });

    return questionnaireDetails;
}

export async function getInitialPsfsValues(answersUuid, patientQuestionnaireUuid) {
    let formattedJson = JSON.stringify({
        requestJson: {
            results: [
                {
                    answersUuid: answersUuid,
                    patientQuestionnaireUuid: patientQuestionnaireUuid,
                },
            ],
        },
    });
    let request = BuildAxiosRequestHeaders("GetInitialPsfsValues", "QPortal");

    let result = "";
    try {
        result = await AxiosRequest(baseUrl, formattedJson, request);
    } catch (e) {
        return 399; //no response
    }

    return { StatusCode: result.data.statusCode, data: result.data.data };
}
